import { render, staticRenderFns } from "./DpSubscribeUser.vue?vue&type=template&id=3d198153"
import script from "./DpSubscribeUser.vue?vue&type=script&lang=js"
export * from "./DpSubscribeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports